/**
 * Forgot Password Request
 */
export type TForgotPasswordRequest = {
  username: string;
};

export type TForgotPasswordResponse = any;

/**
 * Reset Password Request
 */
export type TResetPasswordRequest = {
  newPassword: string;
  verifyPassword: string;
};

export type TResetPasswordResponse = any;

/**
 * Update Password Request
 */
export type TUpdatePasswordRequest = {
  currentPassword: string;
  newPassword: string;
  verifyPassword: string;
};

export type TUpdatePasswordResponse = any;
